import React from "react";
import "./SelectedFilters.scss";
import { Tag } from "antd";

// The filters currently in the URL as removable tags, shown inline in the
// mobile chips row — there the filter sheet is closed most of the time, so
// the tags are the only place a customer sees what narrows the list. Desktop
// needs none: its filter panel is always on screen.
export default function SelectedFilters({ token, items, disabled }) {
  if (!items?.length) {
    return null;
  }

  return (
    <>
      {items?.map((item) => (
        <Tag
          key={item?.key}
          className="selectedFilters-tag"
          style={{
            color: token?.Typography?.mainColorText,
            borderColor: token?.colorPrimary,
            backgroundColor: `color-mix(in srgb, ${token?.colorPrimary} 12%, transparent)`,
          }}
          closable={!disabled}
          onClose={(e) => {
            e.preventDefault();
            if (typeof item?.onRemove === "function") {
              item.onRemove();
            }
          }}>
          {item?.label}
        </Tag>
      ))}
    </>
  );
}
